import React from 'react';
import { Sparkles } from 'lucide-react';
import './AnimatedActionButton.css';

const AnimatedActionButton = ({ 
  onClick, 
  disabled = false, 
  loading = false, 
  children,
  size = 'lg',
  className = ''
}) => {
  const buttonText = loading ? 'Generating...' : children;
  
  return (
    <button
      onClick={onClick}
      disabled={disabled || loading}
      className={`animated-action-button ${size === 'lg' ? 'button-lg' : ''} ${className}`}
    >
      <Sparkles 
        className={`button-icon ${loading ? 'spinning' : ''}`}
        size={20} 
      />
      <span className="button-text">
        {typeof buttonText === 'string' ? (
          buttonText.split('').map((char, index) => (
            <span
              key={index}
              className={char === ' ' ? 'button-space' : 'button-letter'}
              style={{
                '--delay': `${index * 0.05}s`,
                '--wave-delay': `${index * 0.3}s`
              }}
            >
              {char === ' ' ? '\u00A0' : char}
            </span>
          ))
        ) : (
          buttonText
        )}
      </span>
    </button>
  );
};

export default AnimatedActionButton;
